import { useEffect, useState, useMemo, useCallback } from "react";
import { Card, CardBody } from "reactstrap";
import { AiOutlineClose } from "react-icons/ai";
import { CustomAlert } from "components";
import { isReactFragment } from "utils/isReactFragment";
import { triggerActionOnEscape } from "utils/triggerActionOnEscape";
import "./styles.css";

const CustomModal = ({
	compact = false,
	show,
	hideModal,
	title = "",
	children,
	buttons = false,
	isDirty,
	checkDirty,
	triggerAlertWhenClose = false,
	triggerAlertMessageWhenClose = "",
	centered = true,
	zIndex = 0,
	className = "",
}) => {
	const extendedHideModal = useCallback(() => {
		setOpenConfirmationAlert(false);
		hideModal();
	}, []);

	const closeModal = useCallback(() => {
		if (triggerAlertWhenClose && (!checkDirty || (checkDirty && isDirty))) {
			return setOpenConfirmationAlert(true);
		} else extendedHideModal();
	}, [triggerAlertWhenClose, extendedHideModal, checkDirty, isDirty]);

	useEffect(() => {
		const closeModalOnEscape = triggerActionOnEscape(closeModal);
		document.addEventListener("keydown", closeModalOnEscape);
		return () => document.removeEventListener("keydown", closeModalOnEscape);
	}, [closeModal]);

	const [openConfirmationAlert, setOpenConfirmationAlert] = useState(false);

	const checkAnyButtons = useMemo(() => {
		if (isReactFragment(buttons)) {
			const children = buttons.props?.children;
			if (Array.isArray(children) && children.length)
				return children.some((button) => Boolean(button));
		}
		return Boolean(buttons.props?.children);
	}, [buttons]);

	return show ? (
		<>
			<CustomAlert
				show={openConfirmationAlert}
				hideModal={() => setOpenConfirmationAlert(false)}
				title="Confirmation"
				body={
					<div className="text-warning">{triggerAlertMessageWhenClose}</div>
				}
				submitButtonText="Confirm"
				submitModal={extendedHideModal}
			/>
			<div className="close-icon" style={{ zIndex: 9999 + zIndex }}>
				<AiOutlineClose size={20} color="white" onClick={closeModal} />
			</div>
			<div
				className="backdrop"
				style={{ zIndex: 1400 + zIndex }}
				onClick={(e) => {
					e.stopPropagation();
					closeModal();
				}}
			>
				<Card
					onClick={(e) => e.stopPropagation()}
					className={`text-center custom-modal ${className} ${compact ? "p-3" : "p-4"} ${!checkAnyButtons && "full-height "} ${
						centered ? "custom-modal-centered " : ""
					}`}
				>
					<CardBody className={`${compact && "p-0"}`}>
						{title && (
							<div
								className={`text-secondary font-weight-bold display-5 ${compact ? "mt-2 mb-3" : "mb-3 mt-5 mt-sm-3 pb-3"}`}
							>
								{title}
							</div>
						)}

						<div
							className={`d-flex flex-column justify-content-between text-left ${compact ? "pb-1" : "pb-5"}`}
						>
							{children}
						</div>
					</CardBody>
				</Card>
				{checkAnyButtons && (
					<div
						className="position-fixed py-2 shadow"
						style={{
							bottom: 0,
							left: 0,
							backgroundColor: "#2a2c41",
							zIndex: 1500 + zIndex,
							height: 64.89,
							display: "flex",
							minWidth: "100vw",
							maxWidth: "100vw",
							overflowX: "auto",
							justifyContent: "center",
						}}
						onClick={(e) => e.stopPropagation()}
					>
						{buttons}
					</div>
				)}
			</div>
		</>
	) : null;
};

export default CustomModal;
